<template>
  <el-row class="main-sidebar-nav">
    <el-col class="logo-box" :xs={span:0} :sm={span:6} :md={span:5,offset:2} :lg={span:5,offset:4}>
      <img style="    width: 60px;
    height: 60px;
    margin-left: -150px;" src="@/assets/yyimages/yiyuan.png">
     <div class="hospital" >株洲市芦淞区中医骨伤专科医院</div>
    </el-col>
   
    <el-col class="hidden-sm-and-up" :xs={span:3}>
      <el-button icon="el-icon-menu" circle @click="navflag = !navflag"></el-button>
    </el-col>
    <el-col :class="[this.navflag?'nav-hide':'']" :xs={span:21} :sm={span:18} :md={span:15} :lg={span:11}>
      <el-menu :default-active="$route.path" router class="el-menu-demo" mode="horizontal">
        <el-menu-item index="/main">医院首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">医院概况</template>
          <el-menu-item index="/main/cooperative">医院简介</el-menu-item>
          <el-menu-item index="/main/aboutUS">发展历程</el-menu-item>
          <el-menu-item index="/main/honor">医院荣誉</el-menu-item>
          <el-menu-item index="/main/routeDev">主要领导团队</el-menu-item>
          <el-menu-item index="/main/logAudit">省级非遗代表性传承人</el-menu-item>
         
        </el-submenu>
        <el-menu-item index="/main/publicize">政策宣传</el-menu-item>
        <el-menu-item index="/main/service">北张正骨</el-menu-item>

        <el-menu-item index="/main/humanity">党建人文</el-menu-item>
        <el-menu-item index="/main/news">新闻健教</el-menu-item>

      </el-menu>
    </el-col>
  </el-row>
</template>
<script>
  export default {
    data(){
      return{
        navflag:true
      }
    }
  }
</script>
<style lang="scss" scoped>

  .hospital{
    font-family: "Microsoft YaHei", "SimHei", "STXihei", sans-serif; /* 中文黑体系列，稳重专业 */
  font-size: 28px; /* 根据实际场景调整 */
  font-weight: 600; /* 中等加粗，避免过细或过粗 */
  color: #1a3e72; /* 深蓝色，象征医疗专业与信任 */
  letter-spacing: 1px; /* 轻微字距，提升可读性 */
  text-align: center; /* 居中更显正式 */
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); /* 极浅阴影增加层次感 */
  // border-bottom: 2px solid #c49a6c; /* 底部金棕色细线，呼应中医传统 */
  padding-bottom: 8px; /* 下划线间距 */
  display: inline-block; /* 适应内容宽度 */
  margin-top: 12px;
  margin-left: -60px;
  }

  .main-sidebar-nav{
    height: 100%;
    overflow: hidden;
  }
  .main-sidebar-nav .el-menu--horizontal>.el-menu-item.is-active,.main-sidebar-nav .el-menu--horizontal .el-menu .el-menu-item.is-active{
    color: #409eff !important;
  }
  .main-sidebar-nav .el-menu.el-menu--horizontal {
    border-bottom: 0;
  }
  .nav-bbs{
    border: 1px solid #909399;
    padding: 3px 3px 3px 20px;
    background: url("../../assets/images/icon-forum.png") no-repeat;
    background-position-y: center;
    background-position-x: 3px;
    font-size: 12px;
  }
  @media screen and (max-width: 767px){
    .main-sidebar-nav{
      padding: 5px 0;
      // background: url("../../assets/yyimages/yiyuan.png") #fff no-repeat center center;
    }
  }
  
  @media screen and (min-width: 768px){
    .main-sidebar-nav .logo-box{
      height: 100%;
      position: relative;
    }
    .main-sidebar-nav .logo-box img{
      position: absolute;
      top: 50%;
      transform: translate(10px , -50%);
    }
    
    .main-sidebar-nav .el-menu-demo li{
      width: 12%;
      text-align: center;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px !important;
    }
  }
</style>
<style lang="scss">


  .main-sidebar-nav .nav-hide{
    display: none;
  }
  .el-menu--popup{
    min-width: 120px !important;
  }
  @media screen and (max-width: 767px){
    .main-sidebar-nav .el-menu-item,.main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__title{
      height: 40px !important;
      line-height: 40px !important;
    }
    .main-sidebar-nav .el-menu-item, .main-sidebar-nav .el-submenu__title{
      padding: 0 10px !important;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px!important;
    }
  }
  @media screen and (min-width: 768px){
    .main-sidebar-nav .nav-hide{
      display: block;
    }
    .main-sidebar-nav .el-menu-item, .main-sidebar-nav .el-submenu__title{
      padding: 0 !important;
    }
    .main-sidebar-nav .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
      margin-left: 4px!important;
    }
    
    .el-menu--horizontal .el-menu .el-menu-item{
      padding: 0 10px !important;
    }
  }
</style>